import {Controller, useFormContext} from "react-hook-form";
import {Select, Space, Spin} from "antd";
import {FormField, FormFieldError} from "../../../../../../../design-system/form-field";
import {CreateKycBasicFormStepFormValues} from "../../schema-validation";
import {useGetCountries} from "../../../../../../../react-query-hooks/general";

export function KycCountryFormField() {
  const {control} = useFormContext<CreateKycBasicFormStepFormValues>();
  const getCountriesQuery = useGetCountries();
  const countries = getCountriesQuery.data;

  return (
    <FormField
      id="country"
      label="Country of residence"
      renderInput={(id) => (
        <Controller
          control={control}
          name="country"
          render={({field: {onChange, value, ref, onBlur}, fieldState: {error}}) => (
            <Space size={8} direction="vertical" style={{display: "flex"}}>
              <Select
                id={id}
                status={error?.message ? "error" : ""}
                onChange={onChange}
                showSearch
                onBlur={onBlur}
                size="large"
                value={value}
                placeholder="Select your country"
                ref={ref}
                style={{width: "100%"}}
                notFoundContent={
                  getCountriesQuery.isLoading || getCountriesQuery.isFetching ? (
                    <Spin />
                  ) : null
                }
                options={countries?.map((c) => ({
                  value: c.name.toLowerCase(),
                  label: c.name,
                }))}
              />
              <FormFieldError errorMessage={error?.message} />
            </Space>
          )}
        />
      )}
    />
  );
}
